import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";

import Icon from "../../../components/Icon";
import SiteTitle from "../../../helpers/SiteTitle/SiteTitle";
import ErrorMessage from "../../../components/ErrorMessage";
import ShowPassword from "../../../components/ShowPassword";
import { authContext } from "../../../context/AuthContext/AuthContext";
import { loginUserValidation } from "../../../utils/validation/validation";

const LogInAuth = () => {
  const { handleLogin } = useContext(authContext);

  // Validation
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(loginUserValidation),
  });

  return (
    <>
      <SiteTitle title="ورود به حساب کاربری" />

      <section className="auth bg-base d-flex flex-wrap">
        <div className="auth-left d-lg-block d-none">
          <div className="d-flex align-items-center flex-column h-100 justify-content-center">
            <img src="/assets/images/auth/auth-img.png" alt="" />
          </div>
        </div>
        <div className="auth-right py-32 px-24 d-flex flex-column justify-content-center">
          <div className="max-w-464-px mx-auto w-100">
            <div className="text-center">
              <Link to="/" className="mb-40 max-w-290-px">
                <img src="/assets/images/logo.jpg" alt="" />
              </Link>
              <h4 className="mb-12">ورود به حساب کاربری</h4>
              <p className="mb-32 text-secondary-light text-lg">
                به <span className="text-primary fw-semibold">آکسون</span> خوش
                آمدید، لطفا اطلاعات حساب خود را وارد کنید
              </p>
            </div>
            <form autoComplete="off" onSubmit={handleSubmit(handleLogin)}>
              <div className="mb-20">
                <div className="icon-field">
                  <span className="icon top-50 translate-middle-y">
                    <Icon icon="mage:id-card" />
                  </span>
                  <input
                    type="text"
                    className="form-control h-56-px bg-neutral-50 radius-12"
                    placeholder="کدملی"
                    inputMode="numeric"
                    {...register("nationalNumber")}
                  />
                </div>
                <ErrorMessage message={errors.nationalNumber?.message} />
              </div>
              <div className="mb-20">
                <div className="position-relative ">
                  <div className="icon-field">
                    <span className="icon top-50 translate-middle-y">
                      <Icon icon="solar:lock-password-outline" />
                    </span>
                    <input
                      type="password"
                      className="form-control h-56-px bg-neutral-50 radius-12"
                      id="login-password"
                      placeholder="کلمه عبور"
                      {...register("password")}
                    />
                  </div>
                  <ShowPassword inputID="login-password" />
                </div>
                <ErrorMessage message={errors.password?.message} />
              </div>
              <div>
                <Link
                  to="/auth/forget-password"
                  className="text-primary-600 fw-medium"
                >
                  کلمه عبور خود را فراموش کرده‌اید؟
                </Link>
              </div>
              <button
                type="submit"
                className="btn btn-primary text-sm btn-sm px-12 py-16 w-100 radius-12 mt-32"
              >
                {" "}
                ورود به حساب کاربری
              </button>
              <div className="mt-32 center-border-horizontal text-center">
                <span className="bg-base z-1 px-4">یا ورود از طریق</span>
              </div>
              <div className="mt-32">
                <Link
                  to="/auth/login/otp"
                  type="button"
                  className="fw-semibold text-primary-light py-16 border radius-12 text-md d-flex align-items-center justify-content-center gap-12 line-height-1 bg-hover-primary-50"
                >
                  <Icon
                    icon="teenyicons:otp-solid"
                    className="text-primary-600 text-xl line-height-1"
                  />
                  رمز یکبار مصرف
                </Link>
              </div>
              <div className="mt-32 text-center text-sm">
                <p className="mb-0">
                  حساب کاربری ندارید؟{" "}
                  <Link
                    to="/auth/register"
                    className="text-primary-600 fw-semibold"
                  >
                    ثبت نام کنید
                  </Link>
                </p>
              </div>
            </form>
          </div>
        </div>
      </section>
    </>
  );
};

export default LogInAuth;
